import { render } from "./ProjectKeyInformation.vue?vue&type=template&id=6c1a2d6a&scoped=true"
import script from "./ProjectKeyInformation.vue?vue&type=script&lang=js"
export * from "./ProjectKeyInformation.vue?vue&type=script&lang=js"

import "./ProjectKeyInformation.vue?vue&type=style&index=0&id=6c1a2d6a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1a2d6a"]])

export default __exports__